// ** Dropdowns Imports
import { useState, useEffect } from 'react'
import UserDropdown from './UserDropdown'
import NavbarSearch from './NavbarSearch'
import NotificationDropdown from './NotificationDropdown'
import OnlineStatusChecker from './OnlineStatusChecker'

// ** Third Party Components
import { Sun, Moon } from 'react-feather'

// ** Reactstrap Imports
import { Label, NavItem, NavLink, Input } from 'reactstrap'

const NavbarUser = props => {
  // ** Props
  const { skin, setSkin } = props
  
    // ** Tahun Ajaran Options
    const tahunAjaranOptions = [
      { value: 'db_mdn_makassar220242025', label: '2 2024/2025' },
      { value: 'db_mdn_makassar120242025', label: '1 2024/2025' },
      { value: 'db_mdn_makassar220232024', label: '2 2023/2024' },
      { value: 'db_mdn_makassar120232024', label: '1 2023/2024' },
      { value: 'db_mdn_makassar220222023', label: '2 2022/2023' },
      { value: 'db_mdn_makassar120222023', label: '1 2022/2023' }

      // { value: 'db_mdn_makassar120232024', label: '1 2023/2024' },
      // { value: 'db_mdn_makassar220222023', label: '2 2022/2023' },
      // { value: 'db_mdn_makassar120222023', label: '1 2022/2023' }
    ]

     // ** State for selected Tahun Ajaran
  const [selectedTahunAjaran, setSelectedTahunAjaran] = useState('')

  // ** Load Tahun Ajaran from localStorage on mount
  useEffect(() => {
    const savedTahunAjaran = localStorage.getItem('tahun-ajaran')
    if (savedTahunAjaran) {
      setSelectedTahunAjaran(savedTahunAjaran)
    }
  }, [])

  // ** Handle Tahun Ajaran change
  const handleTahunAjaranChange = event => {
    const selectedValue = event.target.value
    setSelectedTahunAjaran(selectedValue)
    localStorage.setItem('tahun-ajaran', selectedValue)
     // Refresh the page
     window.location.reload()

    // Optionally, if you need to set it in headers
    // (replace `setHeaders` with the actual function to set headers in your app)
    // setHeaders({ 'tahun-ajaran': selectedValue })
  }

  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <Sun className='ficon' onClick={() => setSkin('light')} />
    } else {
      return <Moon className='ficon' onClick={() => setSkin('dark')} />
    }
  }

  return (
    <ul className='nav navbar-nav align-items-center ms-auto'>
      
         
      <NavItem className='d-none d-lg-block'>
        <NavLink className='nav-link-style'>
          <ThemeToggler />
        </NavLink>
      </NavItem>   

      <NavItem className='d-none d-lg-block m-lg-1'>
        <NavLink className='nav-link-style'>
        <Label for="tahun-ajaran-select">Tahun Ajaran:</Label>
        </NavLink>
      </NavItem>   

      
      <NavItem className='d-none d-lg-block m-lg-1'>
        <NavLink className='nav-link-style'>
          <Input
            type='select'
            id='tahun-ajaran-select'
            value={selectedTahunAjaran}
            onChange={handleTahunAjaranChange}
            className="small"
          >
            <option value=''>Pilih Tahun Ajaran</option>
            {tahunAjaranOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        </NavLink>
      </NavItem> 

      <NavItem className='d-none d-lg-block m-lg-1'>
        <NavLink className='nav-link-style'>
        <Label><OnlineStatusChecker/></Label>
        </NavLink>
      </NavItem>      
   
       {/* <NavbarSearch /> */}
      {/* <NotificationDropdown /> */}
      <UserDropdown />
    </ul>
  )
}
export default NavbarUser
